// AnnouncerContext.tsx
import { VisuallyHidden } from '@chakra-ui/react';
import React, { createContext, useCallback, useContext, useState } from 'react';

const AnnouncerContext = createContext<{ announce: (msg: string) => void } | null>(null);

export function AnnouncerProvider({ children }: { children: React.ReactNode }) {
  const [message, setMessage] = useState('');

  const announce = useCallback((msg: string) => {
    // Reset first to force re-announcement even if same string
    setMessage('');
    setTimeout(() => setMessage(msg), 1000);
  }, []);

  return (
    <AnnouncerContext.Provider value={{ announce }}>
      {children}
      <VisuallyHidden role="alert" aria-live="polite">
        {message}
      </VisuallyHidden>
    </AnnouncerContext.Provider>
  );
}

export function useAnnouncer() {
  const ctx = useContext(AnnouncerContext);
  if (!ctx) throw new Error('useAnnouncer must be used inside AnnouncerProvider');
  return ctx;
}
